module.exports = __webpack_public_path__ + "static/media/kitting-in-progress.11ecfe1d.svg";